import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=1bfc0f65"
import script from "./subscription.vue?vue&type=script&lang=js"
export * from "./subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfc0f65')) {
      api.createRecord('1bfc0f65', component.options)
    } else {
      api.reload('1bfc0f65', component.options)
    }
    module.hot.accept("./subscription.vue?vue&type=template&id=1bfc0f65", function () {
      api.rerender('1bfc0f65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/subscription/subscription.vue"
export default component.exports